'use strict';

var loader = require('./index');

module.exports = loader.default;
module.exports.raw = loader.raw;


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js
// module id = EPz7
// module chunks = 11